import { Box, Button, Input } from "@chakra-ui/react";
import { Gender, MAX_NAME_LENGTH, MIN_NAME_LENGTH } from "common";
import { useCallback, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAPI } from "../api/useAPI";
import { useAPIQuery } from "../api/useAPIQuery";
import { useOnAPISuccess } from "../api/useOnAPISuccess";
import { useToastOnAPIError } from "../api/useToastOnAPIError";
import { AppPage } from "../utils/AppPage";
import { GenderSelector } from "../utils/GenderSelector";
import { TeamSelector } from "../utils/TeamSelector";
import { THEME_COLOR_SCHEME } from "../utils/theme";
import { isParamNumeric } from "../utils/utils";
import { YearSelector } from "../utils/YearSelector";
import { PropertyForm } from "./PropertyForm";

export const YouthKidCreatePage = () => {
  const [fName, setFName] = useState("");
  const [lName, setLName] = useState("");
  const [year, setYear] = useState<null | number>(null);
  const [gender, setGender] = useState<Gender | null>(null);
  const [teamId, setTeamId] = useState("");
  const api = useAPI();
  const { data, state, error, query } = useAPIQuery<"youthKidPost">({
    apiCall: api.youthKidPost,
  });
  const navigate = useNavigate();
  useToastOnAPIError({ title: "Unable to create youth kid", error });
  useOnAPISuccess<"youthKidPost">({
    data,
    state,
    onSuccess: () => {
      navigate("/people");
    },
  });
  const [properties, setProperties] = useState<{ [name: string]: string }>({});

  const isValid = useMemo(
    () =>
      fName.length >= MIN_NAME_LENGTH &&
      lName.length <= MAX_NAME_LENGTH &&
      lName.length >= MIN_NAME_LENGTH &&
      lName.length <= MAX_NAME_LENGTH &&
      year &&
      gender,
    [fName.length, gender, lName.length, year]
  );

  const onCreate = useCallback(() => {
    if (!year || !gender || state === "loading") {
      return;
    }
    query({
      fName,
      lName,
      year,
      gender,
      ...(isParamNumeric(teamId) ? { teamId: Number(teamId) } : {}),
      properties,
    });
  }, [fName, gender, lName, properties, query, state, teamId, year]);

  return (
    <AppPage title="New youth kid">
      <Box fontWeight={"bold"} fontSize={"large"} marginTop={2}>
        First Name
      </Box>
      <Input
        placeholder="First Name"
        marginBottom={4}
        value={fName}
        onChange={(e) => setFName(e.target.value)}
      />
      <Box fontWeight={"bold"} fontSize={"large"} marginTop={2}>
        Last Name
      </Box>
      <Input
        placeholder="Last Name"
        marginBottom={4}
        value={lName}
        onChange={(e) => setLName(e.target.value)}
      />
      <Box fontWeight={"bold"} fontSize={"large"} marginTop={2}>
        Gender
      </Box>
      <GenderSelector gender={gender} setGender={setGender} />
      <Box fontWeight={"bold"} fontSize={"large"} marginTop={2}>
        Year
      </Box>
      <YearSelector year={year} setYear={setYear} />
      <TeamSelector value={teamId} setValue={setTeamId} />
      <PropertyForm properties={properties} setProperties={setProperties} />
      <Button
        marginTop={8}
        width={"100%"}
        colorScheme={THEME_COLOR_SCHEME}
        isDisabled={!isValid}
        onClick={onCreate}
      >
        Create
      </Button>
    </AppPage>
  );
};
